// (function () {
//   const FRAME_SELECTOR = '[data-index-play-frame]';
//   const SVG_SELECTOR = '.index-play-that-gives-back-frame-svg';
//   const RADIUS = 12;
//   const DIAMETER = RADIUS * 2;
//   const OFFSET = 24;
//   const observers = new WeakMap();
//   function repeatArc(arc, count) {
//     return `${arc} `.repeat(Math.max(count, 1));
//   }
//   function applyImportant(el, props) {
//     for (const key in props) {
//       el.style.setProperty(key, props[key], 'important');
//     }
//   }
//   function ensureWrapperStyles(wrapper) {
//     const computed = window.getComputedStyle(wrapper);
//     if (computed.position === 'static') {
//       wrapper.style.setProperty('position', 'relative', 'important');
//     }
//     if (computed.isolation === 'auto') {
//       wrapper.style.setProperty('isolation', 'isolate', 'important');
//     }
//   }

//   function buildFrame(wrapper) {
//     const svg = wrapper.querySelector(SVG_SELECTOR);
//     if (!(svg instanceof SVGSVGElement)) return;

//     const containerWidth = Math.round(wrapper.offsetWidth);
//     const containerHeight = Math.round(wrapper.offsetHeight);
//     if (!containerWidth || !containerHeight) return;

//     ensureWrapperStyles(wrapper);
//     const svgWidth = containerWidth + OFFSET * 2;
//     const svgHeight = containerHeight + OFFSET * 2;
//     const innerWidth = svgWidth - DIAMETER;
//     const innerHeight = svgHeight - DIAMETER;
//     const horizontalCount = Math.max(1, Math.round(innerWidth / DIAMETER));
//     const verticalCount = Math.max(1, Math.round(innerHeight / DIAMETER));
//     const hStep = innerWidth / horizontalCount;
//     const vStep = innerHeight / verticalCount;
//     const hRx = hStep / 2;
//     const vRy = vStep / 2;
//     const topArc = `a${hRx},${RADIUS} 0 0,1 ${hStep},0`;
//     const rightArc = `a${RADIUS},${vRy} 0 0,1 0,${vStep}`;
//     const bottomArc = `a${hRx},${RADIUS} 0 0,1 ${-hStep},0`;
//     const leftArc = `a${RADIUS},${vRy} 0 0,1 0,${-vStep}`;

//     const path =
//       `M${RADIUS},${RADIUS} ` +
//       repeatArc(topArc, horizontalCount) +
//       repeatArc(rightArc, verticalCount) +
//       repeatArc(bottomArc, horizontalCount) +
//       repeatArc(leftArc, verticalCount) +
//       'Z';

//     svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
//     svg.setAttribute('width', String(svgWidth));
//     svg.setAttribute('height', String(svgHeight));
//     svg.setAttribute('preserveAspectRatio', 'none');
//     applyImportant(svg, {
//       position: 'absolute',
//       top: `-${OFFSET}px`,
//       left: `-${OFFSET}px`,
//       right: 'auto',
//       bottom: 'auto',
//       width: `${svgWidth}px`,
//       height: `${svgHeight}px`,
//       'max-width': 'none',
//       'max-height': 'none',
//       'pointer-events': 'none',
//       overflow: 'visible',
//       'z-index': '-1',
//     });
//     svg.innerHTML = `<path d="${path}" fill="currentColor"></path>`;
//   }
//   function initFrame(wrapper) {
//     if (!(wrapper instanceof HTMLElement)) return;

//     buildFrame(wrapper);
//     window.setTimeout(() => buildFrame(wrapper), 50);
//     window.setTimeout(() => buildFrame(wrapper), 300);

//     if ('ResizeObserver' in window && !observers.has(wrapper)) {
//       const observer = new ResizeObserver(() => buildFrame(wrapper));
//       observer.observe(wrapper);
//       observers.set(wrapper, observer);
//     }
//   }

//   function initFrames(root = document) {
//     root.querySelectorAll(FRAME_SELECTOR).forEach(initFrame);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', () => initFrames(), { once: true });
//   } else {
//     initFrames();
//   }

//   window.addEventListener('load', () => initFrames());
//   window.addEventListener('resize', () => initFrames());

//   document.addEventListener('shopify:section:load', (event) => {
//     initFrames(event.target);
//   });
// })();
// 

(function () {
  const FRAME_SELECTOR = '[data-index-play-frame]';
  const SVG_SELECTOR = '.index-play-that-gives-back-frame-svg';

  // ---- Desktop wave (UNCHANGED) ----
  const RADIUS = 12;
  const DIAMETER = RADIUS * 2;          // 24px wave
  const OFFSET = 24;

  // ---- Mobile wave (per Figma: 20.12 along edge × 12 protrusion) ----
  const MOBILE_WAVE_STEP = 25.12;       // wave width along edge
  const MOBILE_WAVE_HEIGHT = 16;        // protrusion outward (= RADIUS)

  const MOBILE_BREAKPOINT = 749;        // <= 749px is treated as mobile
  const observers = new WeakMap();

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
  }

  function repeatArc(arc, count) {
    return `${arc} `.repeat(Math.max(count, 1));
  }

  function applyImportant(el, props) {
    for (const key in props) {
      el.style.setProperty(key, props[key], 'important');
    }
  }

  function ensureWrapperStyles(wrapper) {
    const computed = window.getComputedStyle(wrapper);
    if (computed.position === 'static') {
      wrapper.style.setProperty('position', 'relative', 'important');
    }
    if (computed.isolation === 'auto') {
      wrapper.style.setProperty('isolation', 'isolate', 'important');
    }
  }

  // ---------- DESKTOP: continuous waves, full fill (UNCHANGED) -------------
  function buildDesktopPath(svgWidth, svgHeight) {
    const innerWidth = svgWidth - DIAMETER;
    const innerHeight = svgHeight - DIAMETER;
    const horizontalCount = Math.max(1, Math.round(innerWidth / DIAMETER));
    const verticalCount = Math.max(1, Math.round(innerHeight / DIAMETER));
    const hStep = innerWidth / horizontalCount;
    const vStep = innerHeight / verticalCount;
    const hRx = hStep / 2;
    const vRy = vStep / 2;
    const topArc = `a${hRx},${RADIUS} 0 0,1 ${hStep},0`;
    const rightArc = `a${RADIUS},${vRy} 0 0,1 0,${vStep}`;
    const bottomArc = `a${hRx},${RADIUS} 0 0,1 ${-hStep},0`;
    const leftArc = `a${RADIUS},${vRy} 0 0,1 0,${-vStep}`;
    return (
      `M${RADIUS},${RADIUS} ` +
      repeatArc(topArc, horizontalCount) +
      repeatArc(rightArc, verticalCount) +
      repeatArc(bottomArc, horizontalCount) +
      repeatArc(leftArc, verticalCount) +
      'Z'
    );
  }

  // ---------- MOBILE: continuous waves at 20.12×12 + donut hole ------------
  // No edge spacing — the first/last wave on every edge runs all the way to
  // the corner and meets the adjacent edge's first wave at the natural cusp,
  // producing the overlapping-corner shape shown in the Figma boxes.
  //
  // The path has TWO sub-paths combined into one <path>:
  //   1. The outer scalloped boundary (the wave ring).
  //   2. An inner rectangle matching the wrapper's edges (the donut hole).
  // With fill-rule="evenodd" only the ring between them is filled, so the
  // wave color never bleeds across the wrapper interior.
  function buildMobilePath(svgWidth, svgHeight, containerWidth, containerHeight) {
    const R = MOBILE_WAVE_HEIGHT;
    const STEP = MOBILE_WAVE_STEP;

    // Wave area uses the same baseline geometry as desktop: R inset from each
    // SVG edge so the bumps protrude into the OFFSET margin.
    const innerWidth = svgWidth - 2 * R;
    const innerHeight = svgHeight - 2 * R;
    const horizontalCount = Math.max(1, Math.round(innerWidth / STEP));
    const verticalCount = Math.max(1, Math.round(innerHeight / STEP));
    const hStep = innerWidth / horizontalCount;   // ≈ 20.12
    const vStep = innerHeight / verticalCount;    // ≈ 20.12
    const hRx = hStep / 2;
    const vRy = vStep / 2;
    const topArc = `a${hRx},${R} 0 0,1 ${hStep},0`;
    const rightArc = `a${R},${vRy} 0 0,1 0,${vStep}`;
    const bottomArc = `a${hRx},${R} 0 0,1 ${-hStep},0`;
    const leftArc = `a${R},${vRy} 0 0,1 0,${-vStep}`;

    const outer =
      `M${R},${R} ` +
      repeatArc(topArc, horizontalCount) +
      repeatArc(rightArc, verticalCount) +
      repeatArc(bottomArc, horizontalCount) +
      repeatArc(leftArc, verticalCount) +
      'Z';

    // Inner rectangle = wrapper bounds in SVG coords (the donut hole).
    const ix0 = OFFSET;
    const iy0 = OFFSET;
    const ix1 = OFFSET + containerWidth;
    const iy1 = OFFSET + containerHeight;
    const inner =
      ` M${ix0},${iy0} ` +
      `L${ix1},${iy0} ` +
      `L${ix1},${iy1} ` +
      `L${ix0},${iy1} ` +
      'Z';

    return outer + inner;
  }

  function buildFrame(wrapper) {
    const svg = wrapper.querySelector(SVG_SELECTOR);
    if (!(svg instanceof SVGSVGElement)) return;

    const containerWidth = Math.round(wrapper.offsetWidth);
    const containerHeight = Math.round(wrapper.offsetHeight);
    if (!containerWidth || !containerHeight) return;

    ensureWrapperStyles(wrapper);
    const svgWidth = containerWidth + OFFSET * 2;
    const svgHeight = containerHeight + OFFSET * 2;

    const mobile = isMobile();
    const path = mobile
      ? buildMobilePath(svgWidth, svgHeight, containerWidth, containerHeight)
      : buildDesktopPath(svgWidth, svgHeight);

    // Mobile: evenodd makes the inner rectangle a transparent hole.
    // Desktop: nonzero (default), full filled scallop shape — unchanged.
    const fillRule = mobile ? 'nonzero' : 'nonzero';

    svg.setAttribute('viewBox', `0 0 ${svgWidth} ${svgHeight}`);
    svg.setAttribute('width', String(svgWidth));
    svg.setAttribute('height', String(svgHeight));
    svg.setAttribute('preserveAspectRatio', 'none');
    applyImportant(svg, {
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      position: 'absolute',
      top: `-${OFFSET}px`,
      left: `-${OFFSET}px`,
      right: 'auto',
      bottom: 'auto',
      width: `${svgWidth}px`,
      height: `${svgHeight}px`,
      'max-width': 'none',
      'max-height': 'none',
      'pointer-events': 'none',
      overflow: 'visible',
      'z-index': '-1',
    });
    svg.innerHTML = `<path d="${path}" fill="currentColor" fill-rule="${fillRule}"></path>`;
  }

  function initFrame(wrapper) {
    if (!(wrapper instanceof HTMLElement)) return;

    buildFrame(wrapper);
    window.setTimeout(() => buildFrame(wrapper), 50);
    window.setTimeout(() => buildFrame(wrapper), 300);

    if ('ResizeObserver' in window && !observers.has(wrapper)) {
      const observer = new ResizeObserver(() => buildFrame(wrapper));
      observer.observe(wrapper);
      observers.set(wrapper, observer);
    }
  }

  function initFrames(root = document) {
    root.querySelectorAll(FRAME_SELECTOR).forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFrames(), { once: true });
  } else {
    initFrames();
  }

  window.addEventListener('load', () => initFrames());
  window.addEventListener('resize', () => initFrames());
  window.addEventListener('orientationchange', () => initFrames());

  if (window.matchMedia) {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const onChange = () => initFrames();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFrames(event.target);
  });
})();